import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getRequestDate, formatDate } from "./Formats";

const AllPurchaseExcel = (data, all, startDate, endDate) => {
  if (!data || data.length === 0) return;
  console.log(data);
  var worksheetname = all
    ? `${getRequestDate(startDate)}-${getRequestDate(endDate)}`
    : data[0].genId;

  // Prepare the worksheet data
  let totalAmounts = 0;
  const worksheetData = data
    .flat()
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .map((item, index) => ({
      "S.No": index + 1,
      ID: item.genId,
      "Created Date": formatDate(item.date),
      "Item Name": item.name,
      "Requested Quantity": item.requestedQty,
      "Recieved Quantity": item.recievedQty,
      Unit: item.unit,
      Status: item.isArrived,
      Total: Math.round((Number(item.total) || 0) * 100) / 100,
      Supplier: item.supplier,
    }));

  // Add total row
  worksheetData.push({});

  const totalAmount = data
    .flat()
    .reduce((sum, item) => sum + (Number(item.total) || 0), 0);

  worksheetData.push({
    "Item Name": "Total",
    Total: `$${totalAmount.toFixed(2)}`,
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, worksheetname);

  // Export to file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const fileData = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(fileData, worksheetname + ".xlsx");
};

export default AllPurchaseExcel;
